import { styled, css } from 'styled-components'
import { brandConfig } from '../../../config/brandConfig'

export const StyledDepositContainer = styled.div`
  ${({ $customMargin }) => css`
    max-height: calc(100svh - ${$customMargin}px);
  `}
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
`

export const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  margin: 15px 24px;
  gap: 10px;

  p {
    margin-bottom: 20px;
    color: ${brandConfig.colors.darkGreys[2].main};
  }
`

export const StyledSpinnerWrapper = styled.div`
  margin: 0 24px;
  min-height: 290px;
  display: flex;
  align-items: center;
  justify-content: center;
`
